module.exports = __webpack_public_path__ + "img/Spazi_scorrimento1.3090aff3.webp";